import { Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonFillIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

export const MessageFormError = ({ message }: { message: string }) => {
  if (!message) return null;

  return (
    <Flex
      gap='$2'
      align='center'
      css={{
        marginBottom: '$3',
      }}
    >
      <ExclamationMarkHexagonFillIcon size={16} color='$error-standard' />
      <ResponsiveFloraTypography
        fontSize='exceptionsAuxiliar'
        color='$backgroundAltSecondary'
        fontWeight='regular'
      >
        {message}
      </ResponsiveFloraTypography>
    </Flex>
  );
};
